export const BloodPreviewConstants = {
    NOT_STARTED : "NOT_STARTED",
    COARSE_STARTED : "COARSE_STARTED",
    COARSE_DONE:"COARSE_DONE",
    CONFIRMED:"CONFIRMED",
    ERRORED_OUT:"ERRORED_OUT",
    CANCELLED:"CANCELLED",
}